export { FormlyForm } from './components/formly.form';
export { FormlyField } from './components/formly.field';
export { FormlyAttributes } from './components/formly.attributes';
export { FormlyConfig } from './services/formly.config';
export { FormlyFormBuilder } from './services/formly.form.builder';
export { FormlyValidationMessages } from './services/formly.validation-messages';
export { FormlyPubSub, FormlyEventEmitter } from './services/formly.event.emitter';
export { Field } from './templates/field';
export { FieldType } from './templates/field.type';
export { FieldWrapper } from './templates/field.wrapper';
export { FormlyModule } from './core.module';
//# sourceMappingURL=core.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/core/src/core.js
// module id = 764
// module chunks = 3